import React, { useState } from "react";
import ImagePopup from "../../imageComponents/image-popup";
import ScrollToTopOnMount from "../../scrollComponents/ScrollToTopOnRoute";

const HomePage = () => {
  const [popupImage, setPopupImage] = useState(null);

  return (
    <div className="px-6 py-12 max-w-4xl mx-auto text-[#2c7b2f] font-[Lora]">
      <ScrollToTopOnMount />

      {/* Header Section */}
      <header className="mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">Welcome to S&amp;J</h1>
        <p className="text-base md:text-lg leading-relaxed text-justify mb-4">
          At S&amp;J, we transform outdoor spaces and empower individuals through expert services and hands-on, 
          AgriSETA-accredited training programs. From high-risk tree felling, fencing, and firebreak creation 
          to specialized skills like chainsaw operation and plant production, we deliver reliable, professional 
          solutions that build lasting client relationships and equip people with sustainable career skills.
        </p>
        <p className="text-base md:text-lg leading-relaxed text-justify">
          Our mission is to exceed expectations through quality workmanship and training, and our vision is to be 
          a leading name in outdoor services and training, reflecting integrity and professionalism every step of the way.
        </p>
      </header>

      {/* Image Gallery Section */}
      <div className="flex flex-wrap justify-center gap-10">
        <div
          className="cursor-pointer rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:scale-105 transition duration-300 flex-1 max-w-sm"
          onClick={() => setPopupImage("images/training-participants1.jpg")}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === "Enter" && setPopupImage("images/training-participants1.jpg")}
        >
          <img
            src="images/training-participants1.jpg"
            alt="Our Services Team"
            className="w-full h-56 md:h-64 object-cover block"
          />
        </div>

        <div
          className="cursor-pointer rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:scale-105 transition duration-300 flex-1 max-w-sm"
          onClick={() => setPopupImage("images/training-participants2.jpg")}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === "Enter" && setPopupImage("images/training-participants2.jpg")}
        >
          <img
            src="images/training-participants2.jpg"
            alt="Our Training Team"
            className="w-full h-56 md:h-64 object-cover block"
          />
        </div>
      </div>

      {/* Image Popup Modal */}
      <ImagePopup
        imageSrc={popupImage}
        altText="Enlarged Image"
        onClose={() => setPopupImage(null)}
      />
    </div>
  );
};

export default HomePage;
